export default __webpack_public_path__ + "static/media/pending-doc.ed1ad99f.svg";